import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NgbModalModule, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { TippyModule } from '@ngneat/helipopper';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { CitationModule } from 'app/citation/citation.module';
import { ShareItModule } from 'app/share-it/share-it.module';
import { SharedModule } from 'common/shared.module';
import { CardHeaderComponent } from 'full-card-header/card-header.component';
import { DragScrollModule } from 'ngx-drag-scroll';
import { FeatureToggleModule } from 'ngx-feature-toggle';
import { PERFECT_SCROLLBAR_CONFIG, PerfectScrollbarConfigInterface, PerfectScrollbarModule, } from 'ngx-perfect-scrollbar';
import { NlbHoldModule } from '../../customer-integration/nlb/nlb-hold/nlb-hold.module';
import { EntityModule } from '../../entity/entity.module';
import { ListModule } from '../../list/list.module';
import { CardBodyComponent } from './components/card-body/card-body.component';
import { FormatGroupCardHeaderComponent } from './components/format-group-card-header/format-group-card-header.component';
import { FormatGroupToolbarLineComponent } from './components/format-group-toolbar-line/format-group-toolbar-line.component';
import { RollupTabsCardHeaderComponent } from './components/rollup-tabs-card-header/rollup-tabs-card-header.component';
import { RollupTabsContentCardHeaderComponent } from './components/rollup-tabs-content-card-header/rollup-tabs-content-card-header.component';
import { ContributorComponent } from './components/showcases/components/contributor/contributor.component';
import { ContributorsComponent } from './components/showcases/components/contributors/contributors.component';
import { ItemsListComponent } from './components/showcases/components/items-list/items-list.component';
import { MultipleShowcaseComponent } from './components/showcases/components/multiple-showcase/multiple-showcase.component';
import { MultipleShowcasesViewComponent } from './components/showcases/components/multiple-showcases-view/multiple-showcases-view.component';
import { SeeAllButtonComponent } from './components/showcases/components/see-all-button/see-all-button.component';
import { ShowcaseCreatedByComponent } from './components/showcases/components/showcase-created-by/showcase-created-by.component';
import { ShowcaseHeaderComponent } from './components/showcases/components/showcase-header/showcase-header.component';
import { SingleShowcaseResourceComponent } from './components/showcases/components/single-showcase-resource/single-showcase-resource.component';
import { SingleShowcaseViewComponent } from './components/showcases/components/single-showcase-view/single-showcase-view.component';
import { SeeAllPageComponent } from './components/showcases/pages/see-all-page/see-all-page.component';
import { ShowcasePageComponent } from './components/showcases/pages/showcase-page/showcase-page.component';
import { ShowcasesContainerComponent } from './components/showcases/showcases-container.component';
import { CardContainerComponent } from './containers/card-container.component';
import { ShowcasesEffects } from './effects/showcases.effects';
import { FullCardRoutingModule } from './full-card-routing.module';
import { fullCardReducers } from './reducers/full-card.reducer';
import { ShowcasesService as showcases } from './services/showcases.service';
import { NytShowcaseViewComponent } from './components/showcases/components/nyt-showcase-view/nyt-showcase-view.component';
import { ElementsV2Module } from '../../elements-v2/elements-v2.module';
import { NlbQrCodeModule } from '../../customer-integration/nlb/nlb-qr-code/nlb-qr-code.module';
import { JsonldModule } from '../../jsonld/jsonld.module';
import { NlbItemLocatorModule } from '../../customer-integration/nlb/nlb-item-locator/nlb-item-locator.module';
import { NlbBorrowNDeliverModule } from '../../customer-integration/nlb/nlb-borrow-n-deliver/nlb-borrow-n-deliver.module';
import { RollupTabsCardHeaderRapidoComponent } from './components/rollup-tabs-card-header-rapido/rollup-tabs-card-header-rapido.component';
import { RollupTabsContentCardHeaderRapidoComponent }
  from './components/rollup-tabs-content-card-header-rapido/rollup-tabs-content-card-header-rapido.component';

const COMPONENTS = [
  CardContainerComponent,
  ShowcasesContainerComponent,
  SingleShowcaseViewComponent,
  ContributorsComponent,
  ContributorComponent,
  MultipleShowcasesViewComponent,
  SeeAllButtonComponent,
  ShowcasePageComponent,
  FormatGroupToolbarLineComponent,
  CardHeaderComponent,
  FormatGroupCardHeaderComponent,
  RollupTabsCardHeaderComponent,
  RollupTabsContentCardHeaderComponent,
  SeeAllPageComponent,
  ItemsListComponent,
  SingleShowcaseResourceComponent,
  MultipleShowcaseComponent,
  CardBodyComponent,
  ShowcaseHeaderComponent,
  ShowcaseCreatedByComponent,
  NytShowcaseViewComponent,
  RollupTabsCardHeaderRapidoComponent,
  RollupTabsContentCardHeaderRapidoComponent
];

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
};

@NgModule({
  imports: [
    CommonModule,
    FullCardRoutingModule,
    EffectsModule.forFeature([ShowcasesEffects]),
    StoreModule.forFeature('fullCard', fullCardReducers),
    SharedModule,
    DragScrollModule,
    PerfectScrollbarModule,
    TippyModule,
    NgbModalModule,
    NgbNavModule,
    ShareItModule,
    CitationModule,
    ListModule,
    FeatureToggleModule,
    FontAwesomeModule,
    EntityModule,
    ElementsV2Module,
    NlbQrCodeModule,
    NlbHoldModule,
    JsonldModule,
    NlbItemLocatorModule,
    NlbBorrowNDeliverModule
  ],
  declarations: [ ...COMPONENTS ],
  providers: [
    showcases,
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG,
    },
  ],
})
export class FullCardModule { }
